<template>
  <el-drawer
    :title="title"
    :visible.sync="showDrawer"
    :with-header="true"
    :before-close="handleClose"
    :size="drawerWidth"
  >
    <component @closeDrawer="handleClose" :is="drawerContent" />
  </el-drawer>
</template>
<script>
import breakpoints from '@/utils/breakpoints.js'
export default {
  name: 'Drawer',
  data () {
    return {
      breakpoints,
      title: ''
    }
  },
  props: {
    showDrawer: {
      type: Boolean,
      required: true
    },
    drawerContent: {
      type: String,
      required: true
    }
  },
  components: {
    CardDrawerContent: () =>
      import('@/components/v2/dashboard/drawerContent/CardDrawerContent.vue'),
    ExchangeRateDrawerContent: () =>
      import(
        '@/components/v2/dashboard/drawerContent/ExchangeRateDrawerContent'
      ),
    ComingSoonContent: () =>
      import('@/components/v2/dashboard/drawerContent/ComingSoonContent.vue'),
    AccountDetailsContent: () =>
      import(
        '@/components/v2/dashboard/drawerContent/AccountDetailsContent.vue'
      )
  },
  computed: {
    drawerWidth () {
      return breakpoints.lgAndUp ? '30%' : breakpoints.mdAndUp ? '70%' : '90%'
    }
  },
  created () {
    if (this.drawerContent === 'exchange-rate-drawer-content') {
      this.title = 'Exchange Rates'
    } else if (this.drawerContent === 'coming-soon-content') {
      this.title = ''
    } else if (this.drawerContent === 'card-drawer-content') {
      this.title = 'Cards'
    } else if (this.drawerContent === 'account-details-content') {
      this.title = 'Account Details'
    }
  },
  methods: {
    handleClose () {
      this.$emit('closeDrawer')
    }
  }
}
</script>
<style scoped>
>>> .el-drawer__header {
  color: var(--text-4);
  font-size: 1.2rem;
  padding-bottom: 1rem;
  padding-top: 2rem;
  padding-left: 2.5rem;
  font-weight: 700;
  border-bottom: 1px solid var(--border-main);
}
>>> .el-drawer {
  background: var(--background-surface) !important;
}
</style>
